import {IVideoAnalyticsReporter} from "./video-analytics-reporter.interface";
import {IVideoResolution} from "../video-player.view-model.interface";
import {TimeSpan} from "@sparkware/app-utils";

export class VideoConsoleAnalyticsReporter implements IVideoAnalyticsReporter {

    reportPlayStarted(): void {
        console.log(`video: Play started`);
    }

    reportRetryPlaySuccess() {
        console.log(`video: Retry play success`);
    }

    reportResumePlaySuccess() {
        console.log(`video: Resume play success`);
    }

    reportPauseOnAppSleep() {
        console.log(`video: Pause on app sleep`);
    }

    reportPreloadError(error: any) {
        console.error(`video: Preload error: Name = ${error.name} | Message = ${error.message}`, error);
    }

    reportPlayError(error: any): void {
        console.error(`video: Play error: Name = ${error.name} | Message = ${error.message}`, error);
    }

    reportRetryPlayError(error:any) {
        console.error(`video: retry play error`, error);
    }

    reportResumePlayError(error: any): void {
        console.error(`video: resume play error`, error);
    }

    reportDroppedFrames(droppedVideoFrames: number): void {
        if(droppedVideoFrames > 15) {
            console.log(`video: dropped frames: ${droppedVideoFrames}`);
        }
    }

    reportWatchTimeLimitReached(): void {
        console.log(`video: watch time limit reached`);
    }

    reportPosterLoadFailure(error: any): void {
        console.log('video: poster load failure:', error);
    }

    reportVideoResolutionChanged(previousResolution: IVideoResolution, currentResolution: IVideoResolution): void {
        console.log(`video: resolution changed: ${previousResolution.width} x ${previousResolution.height} => ${currentResolution.width} x ${currentResolution.height}`);
    }

    reportBufferingTime(bufferingTime: TimeSpan): void {
        if(bufferingTime.totalSeconds > 1) {
            console.log('video: buffering time:', bufferingTime.totalSeconds);
        }
    }

    reportMute() {
        console.log('video: muted');
    }

    reportUnmute() {
        console.log('video: unmuted');
    }
}